import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'

const attendanceOccurrence: Dataset = {
  schema: 'public_health',
  table: 'attendance_occurrence',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    attendance_original_id: original => original,
    icd10_code: original => original,
    icpc2_code: original => original,
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default attendanceOccurrence
